import { PropsWithChildren } from "react";
import { CesiumProvider } from "components/elements/CesiumViewer/core/useCesium";
import { SpatialViewerProvider } from "./SpatialViewerContext";
import { IssueCreateProvider } from "components/modules/Issues/lib/contexts/IssueCreateContext";
import { ToolEffectHooksProvider } from "components/elements/CesiumViewer/core/tools/ToolEffectHooksProvider";
import { ViewsModeProvider } from "lib/contexts/SpatialContexts/ViewsModeContext";
import { ViewsCaptureFlashProvider } from "lib/contexts/SpatialContexts/ViewsCaptureFlashContext";
import { ControlsPresetLoader } from "lib/contexts/SpatialContexts/ControlsPresetLoader";

const SpatialProviders = (p: PropsWithChildren) => (
  <CesiumProvider>
    <SpatialViewerProvider>
      <ToolEffectHooksProvider>
        <ControlsPresetLoader>
          <IssueCreateProvider>
            <ViewsModeProvider>
              <ViewsCaptureFlashProvider>
                {p.children}
              </ViewsCaptureFlashProvider>
            </ViewsModeProvider>
          </IssueCreateProvider>
        </ControlsPresetLoader>
      </ToolEffectHooksProvider>
    </SpatialViewerProvider>
  </CesiumProvider>
);

export default SpatialProviders;
